import { createEmptyFetchable, createFetchableReducer } from 'helpers/loadableHelpers'
import { Reducer } from 'interfaces'
import { CCLockCardAction, CCUnlockCardAction, ResetCCLockCardAction } from 'components/features/creditCard/creditCardStore/actions'
import { CreditCardAppState } from 'components/features/creditCard/creditCardStore/state'
import { KILL_ALL_FLOATING_PANES, KILL_FLOATING_PANES, MODIFY_FLOATING_PANE } from 'actions/floatingPanesActions'

const lockReducer = createFetchableReducer<null>()
const LOCK_INITIAL_STATE = createEmptyFetchable<null>()
export const lockCardRequestReducer: Reducer<CreditCardAppState['lockCardRequest']> = (prevState = LOCK_INITIAL_STATE, action) => {
  switch (action.type) {
    case CCLockCardAction.type: {
      return lockReducer(prevState, action)
    }

    case ResetCCLockCardAction.type:
    case KILL_ALL_FLOATING_PANES:
    case KILL_FLOATING_PANES:
    case MODIFY_FLOATING_PANE: {
      const { errorsMap, ...prevCleanState } = prevState
      return {
        ...prevCleanState,
        errorCode: null,
      }
    }
  }

  return prevState
}

const unlockReducer = createFetchableReducer<null>()
const UNLOCK_INITIAL_STATE = createEmptyFetchable<null>()
export const unlockCardRequestReducer: Reducer<CreditCardAppState['unlockCardRequest']> = (prevState = UNLOCK_INITIAL_STATE, action) => {
  switch (action.type) {
    case CCUnlockCardAction.type: {
      return unlockReducer(prevState, action)
    }

    case ResetCCLockCardAction.type:
    case KILL_ALL_FLOATING_PANES:
    case KILL_FLOATING_PANES:
    case MODIFY_FLOATING_PANE: {
      const { errorsMap, ...prevCleanState } = prevState
      return {
        ...prevCleanState,
        errorCode: null,
      }
    }
  }

  return prevState
}


